<ng-template custom-host></ng-template>